import { createSlice } from '@reduxjs/toolkit'

import {
    resetActiveTab,
    setActiveTab
} from './tabActions'

import ITab from '../../../../interface/core/ITab';
import { IType } from '../../../../interface/IType';

const initialState: ITab = {
  eventKey: undefined,
  type: IType.tab
};

const tabSlice = createSlice({
  name: "tab",
  initialState,
  reducers: {
   /*setAuthData(state, action: PayloadAction<IAuthData>) {

      //console.log('reduxtoolkit: setFormData:');
      //console.log(action.payload);

      //state = action.payload

      console.log('reduxtoolkit: action.payload:');
      console.log(action.payload);

      return action.payload
    },
    resetAuthData(state, action: PayloadAction<IAuthData>) {
      return initialState
    }*/
  },
  extraReducers: (builder) => {
    builder
        .addCase(setActiveTab, (state, action) => {
          Object.assign(state, action.payload);
        })
        .addCase(resetActiveTab, (state, action) => {
          //Object.assign(state, initialState);
          return initialState;
        })
  }
})

export default tabSlice.reducer
